import React, { Component } from 'react';
import GovernmentTableBase from './GovernmentTableBase';

const tableHeaders = ['Range', 'EE', 'ER', 'EC', 'Total'];
const loadTableUrl = 'api/SssTable/load'
const saveTableUrl = 'api/SssTable/save'
const resetTableUrl = 'api/SssTable/reset'

export default class SSSTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ minWidth: '500px', width: '100%' }}>
                <div style={{ color: "#606060", marginTop: '1%' }}>
                    <h2>SSS Table</h2>
                </div>

                <GovernmentTableBase
                    ref={(x) => this.baseTable = x}
                    headers={tableHeaders}
                    loadTableUrl={loadTableUrl}
                    saveTableUrl={saveTableUrl}
                    resetTableUrl={resetTableUrl}
                    year={this.props.year}
                    resetButtonEnable={this.props.resetButtonEnable}
                />
            </div>
        )
    }
}